import {placeholderTypes} from "../../Types/Placeholder";
const placeholders =  [
    {
        replacementKey: 'Resources', values:
            [
                { id: 1, isActive: true, field: 'DelegationClause', display: 'You are notified that the following specific powers' },
            ],
        type:placeholderTypes.RESOURCES
    },
    {
        replacementKey: 'ActionReminders', values:[],
        type:placeholderTypes.ACTION_REMINDERS
    },
    {
        replacementKey: 'UnifiedClauses', values:
            [
                { id: 1, wfid: 27, isActive: true, field: '', display: '$WF_27_NOTIFICATION_NAME Example Clause', },
                { id: 2, wfid: 28, isActive: true, field: '', display: '$WF_28_NOTIFICATION_NAME Example Clause', },
                { id: 3, wfid: 29, isActive: true, field: '', display: '$WF_29_NOTIFICATION_NAME Example Clause', }
            ],
        skipDefaultLoadingIfMissing: true,
        allowCustomReplyPeriods: true,
        allowConfigureReplyParty: true,
        type: placeholderTypes.UNIFIED_CLAUSES
    },
    {
        replacementKey: 'AllowCrossPartyDelegations', values:
            [
                { id: 1, isActive: false, field: 'AllowCrossPartyDelegations', display: 'Set this to allow the sender to delegate to any contract user irrespective of which party the user is assigned to' },

            ],
            isToggle: true,
            fieldRequired: true,
            type:placeholderTypes.TOGGLE_SWITCH
    },
];

export default placeholders;